export default __webpack_public_path__ + "static/media/500.3221fd8a.png";